module.exports = __webpack_public_path__ + "article-7051a3ee/anonyme-bewerbung-ein-schritt-in-richtung-chancengleichheit-305c5675588ef53a81e122095d62af3a.jpg";